import styled from 'styled-components'
import { tabletBreakpoint } from 'react-components'

export const AmenitiesPopupWrapper = styled.div`
    display: ${({ theme }) => theme.style.display.flex};
    flex-direction: ${({ theme }) => theme.style.flexDirection.column};
    padding: ${({ theme }) => `${theme.spacing.medium}`};
    padding-top: 0;
    max-height: 100%;
    height: 100%;
    max-width: 100%;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        max-width: 900px;
    }
`

export const AmenitiesPopupTitle = styled.div`
    display: ${({ theme }) => theme.style.display.flex};
    justify-content: ${({ theme }) => theme.style.justifyContent.flexStart};
    align-items: ${({ theme }) => theme.style.alignItems.center};
    padding: ${({ theme }) => `${theme.spacing.medium} 0`};
`

export const RoomsWrapper = styled.div`
    display: ${({ theme }) => theme.style.display.flex};
    flex-direction: ${({ theme }) => theme.style.flexDirection.column};
    padding-bottom: ${({ theme }) => `${theme.spacing.medium}`};
`

export const RoomsTitleDescription = styled.div`
    display: ${({ theme }) => theme.style.display.flex};
    flex-direction: ${({ theme }) => theme.style.flexDirection.column};
    padding: ${({ theme }) => `${theme.spacing.xSmall} 0`};
`

export const RoomsDescription = styled.div`
    display: ${({ theme }) => theme.style.display.flex};
    flex-direction: ${({ theme }) => theme.style.flexDirection.row};
    flex-wrap: ${({ theme }) => theme.style.flexWrap.wrap};
`

export const RoomItems = styled.div`
    display: ${({ theme }) => theme.style.display.flex};
    flex-direction: ${({ theme }) => theme.style.flexDirection.row};
    flex-wrap: ${({ theme }) => theme.style.flexWrap.wrap};
`
export const RoomItem = styled.div`
    display: ${({ theme }) => theme.style.display.flex};
    flex: 1;
    flex-direction: ${({ theme }) => theme.style.flexDirection.row};
    min-width: 48%;
    max-width: 48%;
    gap: ${({ theme }) => theme.spacing.xSmall};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        width: 30%;
        min-width: 30%;
        max-width: 30%;
    }
`

export const TabBar = styled.div`
    display: flex;
    flex: 1;
    overflow-x: auto;
    position: sticky;
    top: -2px;
    background: white;
    z-index: 10;
    scroll-behavior: smooth;
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
        display: none; /* WebKit browsers (Chrome, Safari) */
    }
    margin: ${({ theme }) => `0 -${theme.spacing.medium}`};
    padding: ${({ theme }) => `0 ${theme.spacing.medium}`};
    border-bottom: 1px solid ${({ theme }) => theme.colors.tfwBlack10};
`

export const Tab = styled.button<{ isActive: boolean }>`
    display: ${({ theme }) => theme.style.display.flex};
    flex-direction: ${({ theme }) => theme.style.flexDirection.row};
    justify-content: ${({ theme }) => theme.style.justifyContent.center};
    align-items: ${({ theme }) => theme.style.alignItems.center};
    padding: ${({ theme }) => `${theme.spacing.xSmall} 0`};
    margin-right: ${({ theme }) => `${theme.spacing.large}`};
    border-bottom: ${({ isActive, theme }) => (isActive ? `2px solid ${theme.colors.black}` : 'none')};
    min-width: fit-content;
    cursor: pointer;
`
